import window from 'bits/global'

export const appInteractionStarted = (): void => {
  return window.ww.appVariant && window.ww.appVariant.interactionStarted()
}
